import React, { useState, useEffect } from 'react';
import Sidemenu from '../base/sidemenu';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchSevList, editUserInfo } from "../../services/userApiServicer";
import { formatMobilePhone } from "../../utils/phoneFormatter";
import useDaumPostcode from "../../hooks/useDaumPostcode";
import DaumPostcode from 'react-daum-postcode';

export default function UserEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userData = location.state?.userData;

  console.log("📦 location.state.userData 값:", userData);
  const today = new Date().toISOString().split('T')[0];

  const [name, setName] = useState('');
  const [birth, setBirth] = useState('');
  const [sex, setSex] = useState('');
  const [address, setAddress] = useState('');
  const [detail_address, setDetailAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [pec, setPec] = useState('');
  const [sevList, setSevList] = useState([]);
  const [severity_id, setSelectedSevId] = useState(userData?.sev_id || "");
  const [departmentList, setDepartmentList] = useState([]);
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');
  const [new_password, setNewPassword] = useState('');
  const [id, setId] = useState('');

  // ✅ 여러 담당관리자 ID 관리
  const [departmentIds, setDepartmentIds] = useState([]);

  const handleMobilePhoneChange = (e) => {
    const formattedValue = formatMobilePhone(e.target.value);
    setPhone(formattedValue);
  };

  const { isOpen, setIsOpen, handleComplete, popupRef } = useDaumPostcode(setAddress);

  useEffect(() => {
    const getSevList = async () => {
      try {
        const data = await fetchSevList(token);
        if (data.success === false) {
          alert(data.message);
          return;
        }
        setSevList(data.severity);
      } catch (error) {
        console.error("🚨 서비스 목록 불러오기 실패:", error);
      }
    };

    const fetchDepartmentList = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/department`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await response.json();
        if (result.success !== false) {
          setDepartmentList(result.department);
        } else {
          console.error("🚨 부서 목록 불러오기 실패:", result.message);
        }
      } catch (error) {
        console.error("🚨 부서 목록 불러오기 오류:", error);
      }
    };

    getSevList();
    fetchDepartmentList();
}, [token]);

  useEffect(() => {
  if (!userData || departmentList.length === 0) return; // ✅ 조건 충족 시에만 실행

  setName(userData.name || '');
  setBirth(userData.birth || '');
  setSex(userData.sex === "남성" ? "male" : userData.sex === "여성" ? "female" : '');
  setDetailAddress(userData.detail_address || '');
  setId(userData.id || '');
  setAddress(userData.address || '');
  setPhone(userData.phone || '');
  setPec(userData.pec || '');
  setUserid(userData.username || '');
  setSelectedSevId(userData.sev_id || '');

  // ✅ 담당관리 초기화
  if (userData.department_name) {
    const names = userData.department_name.split(",").map((n) => n.trim());
    const matchedIds = names
      .map((name) => {
        const dep = departmentList.find((d) => d.name === name);
        return dep ? dep.id : "";
      })
      .filter((id) => id !== "");
    setDepartmentIds(matchedIds.length > 0 ? matchedIds : [""]);
  } else {
    setDepartmentIds([""]);
  }
}, [userData, departmentList]); // ✅ departmentList 준비 후 1회만 실행


  // ✅ 담당관리 추가
  const addDepartment = () => {
    setDepartmentIds([...departmentIds, ""]);
  };

  // ✅ 담당관리 삭제
  const removeDepartment = (index) => {
    if (departmentIds.length > 1) {
      setDepartmentIds(departmentIds.filter((_, i) => i !== index));
    }
  };

  // ✅ 담당관리 선택 변경
  const handleDepartmentChange = (index, value) => {
    const updated = [...departmentIds];
    updated[index] = value;
    setDepartmentIds(updated);
  };

  const handleGoBack = () => navigate(-1);

  // ✅ 수정 완료
  const handleUpdate = async () => {
    try {
      const response = await editUserInfo(token, {
        id,
        name,
        birth,
        sex,
        address,
        detail_address,
        phone,
        pec,
        password,
        new_password,
        department_id: departmentIds, // ✅ 여러 담당관리 전달
        severity_id,
      });

      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }

      alert(response.data.message);
      navigate(`/user/${userData.id}`);
    } catch (error) {
      console.error("🚨 수정 요청 실패:", error);
      alert("수정 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="user">
        <h1>사용자 관리</h1>
        <div className="user_box">
          <h2 className="subpage_title">
            <span className="before"><span className="nametit">사용자 수정</span></span>
          </h2>

          <div className='user_edit'>
            <div className='table02'>
              <table>
                <caption>사용자 수정 표</caption>
                <colgroup>
                  <col width="20%" />
                  <col width="80%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope='row'>이름</th>
                    <td><input type="text" value={name} onChange={e => setName(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>생년월일</th>
                    <td><input type="date" max={today} className='date' value={birth} onChange={e => setBirth(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>성별</th>
                    <td>
                      <input type="radio" name="sex" id="man" value="male" checked={sex === "male"} onChange={e => setSex(e.target.value)} />
                      <label htmlFor="man">남성</label>
                      <input type="radio" name="sex" id="woman" value="female" checked={sex === "female"} onChange={e => setSex(e.target.value)} />
                      <label htmlFor="woman">여성</label>
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>전화번호</th>
                    <td><input type="text" value={phone} onChange={handleMobilePhoneChange} /></td>
                  </tr>
                  <tr>
                    <th scope="row">주소</th>
                    <td style={{ position: 'relative' }}>
                      <input
                        type="text"
                        placeholder="사용자의 주소를 입력하세요."
                        value={address}
                        readOnly
                        onClick={() => setIsOpen(true)}
                      />
                      {isOpen && (
                        <div
                          ref={popupRef}
                          style={{
                            position: 'absolute',
                            zIndex: 100,
                            border: '1px solid #ccc',
                            backgroundColor: '#fff',
                          }}
                        >
                          <DaumPostcode onComplete={handleComplete} />
                        </div>
                      )}
                      <br />
                      <input
                        type="text"
                        placeholder="상세 주소를 입력하세요."
                        value={detail_address}
                        onChange={(e) => setDetailAddress(e.target.value)}
                      />
                    </td>
                  </tr>

                  {/* ✅ 담당관리 */}
                  <tr>
                    <th scope='row'>담당관리</th>
                    <td>
                      {departmentIds.map((depId, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                          <select
                            value={depId}
                            onChange={e => handleDepartmentChange(index, e.target.value)}
                          >
                            <option value="" disabled>담당 관리소속을 선택하세요.</option>
                            {Array.isArray(departmentList) && departmentList.map(department => (
                              <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                          </select>
                          {departmentIds.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeDepartment(index)}
                              style={{ marginLeft: '8px' }}
                            >
                              삭제
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addDepartment}
                        style={{
                          padding: '2px 5px',
                          marginTop: '5px',
                          backgroundColor: '#007BFF',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '4px'
                        }}
                      >
                        + 추가
                      </button>
                    </td>
                  </tr>

                  <tr>
                    <th scope='row'>지병</th>
                    <td><input type="text" value={pec} onChange={e => setPec(e.target.value)} /></td>
                  </tr>
                  <tr>
                    <th scope='row'>위험군 등급</th>
                    <td>
                      <select value={severity_id} onChange={e => setSelectedSevId(e.target.value)}>
                        <option value="" disabled>위험군 등급을 선택하세요.</option>
                        {Array.isArray(sevList) && sevList.map(sev => (
                          <option key={sev.id} value={sev.id}>{sev.name}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>아이디</th>
                    <td><input type="text" value={userid} disabled /></td>
                  </tr>
                  <tr>
                    <th scope='row'>현재 비밀번호</th>
                    <td><input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder='비밀번호 변경시 기존의 비밀번호를 입력하세요.' /></td>
                  </tr>
                  <tr>
                    <th scope='row'>새 비밀번호</th>
                    <td><input type="password" value={new_password} onChange={e => setNewPassword(e.target.value)} placeholder='변경할 새 비밀번호를 입력하세요.' /></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="btn-group">
            <button className="btncolor02" onClick={handleGoBack}>뒤로</button>
            <button className='btncolor03' onClick={() => navigate("/user/edit/family", { state: { userData } })}>가족수정</button>
            <button className="btncolor01" onClick={handleUpdate}>수정완료</button>
          </div>
        </div>
      </div>
    </div>
  );
}
